import "./ProfilePage.scss";

import React, { useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ReactComponent as Add } from "../../assets/icons/add.svg";
import icons from "../../assets/sport-icons/_sportIcons";
import FollowButton from "../../components/essentials/btns/follow-btn/FollowButton";
import Button from "../../components/essentials/button/Button";
import ClickIcon from "../../components/essentials/icon-buttons/click-icon/ClickIcon";
import AcedSelect, {
	SelectOptions,
} from "../../components/essentials/input/select/AcedSelect";
import AcedTextArea from "../../components/essentials/input/text-area/AcedTextArea";
import AcedInput from "../../components/essentials/input/text/AcedInput";
import AcedModal from "../../components/essentials/modals/aced-modal/AcedModal";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import { selectUser, setProfile, setUser } from "../../core/auth/authSlice";
import { FollowApiRoutes } from "../../shared/api-routes/member/follow-api.routes";
import { MembersApiRoutes } from "../../shared/api-routes/member/members-api.routes";
import { ProfilePictureApiRoutes } from "../../shared/api-routes/member/profile-picture.api-routes";
import { ProfileData, User } from "../../shared/models";
import http from "../../shared/utils/http";
import SelectProfilePicture from "../complete-profile/profile-picture/SelectProfilePicture";
import ExperienceCard, {
	ExperienceInfo,
} from "./components/experience-card/ExperienceCard";
import FollowersModal from "./components/followers-modal/FollowersModal";

import userplaceholder from "../../assets/images/userPlaceholder.png";
import { MsgButton } from "../../components/essentials/btns/msg-btn/MsgButton";
import { useIsTouchDevice } from "../../shared/customHooks";
import { getProfilePictureUrl } from "../../shared/utils/profilePictureUrl";
import { capitalizeName, formatDateForInput } from "../../shared/utils/util";

const Profile: React.FC = () => {
	const params = useParams();

	// const [isToggleEnabled, setToggle] = useState(false);
	const [editBio, setEditBio] = useState(false);
	const [editStats, setEditStats] = useState(false);

	const [profileData, setProfileData] = useState<ProfileData>();
	const [expArray, setExpArray] = useState<ExperienceInfo[]>([]);
	const [genderOptions, setGenderOptions] = useState<SelectOptions>([]);
	const [sportOptions, setSportOptions] = useState<SelectOptions>([]);
	const [positionOptions, setPositionOptions] = useState<SelectOptions>([]);
	const [newExp, setNewExp] = useState(false);
	const [followers, setFollowers] = useState<number>(0);
	const [isFollowed, setIsFollowed] = useState<boolean>(false);

	const [isFollowersModalOpen, setFollowersModalOpen] =
		useState<boolean>(false);
	const [isPictureModalOpen, setPictureModalOpen] = useState<boolean>(false);
	const [isBasicInfoModalOpen, setBasicInfoModalOpen] =
		useState<boolean>(false);
	const [isProfilePictureHovered, setProfilePictureHovered] =
		useState<boolean>(false);

	// const toggleSwitch = () => setToggle((previousState) => !previousState);

	const dispatch = useDispatch();
	const { t } = useTranslation();
	const isTouch = useIsTouchDevice();
	const { actorId, avatarVersion } = useSelector(selectUser) as User;

	const SelectSportIcon = () => {
		type SportIconName = keyof typeof icons; // 'CCSki' | 'alpSki' | ... etc.

		const sport = profileData?.sport as SportIconName | undefined;
		const Icon = sport && icons[sport];
		return Icon ? (
			<div className="profile__heading-sport-guy">
				<Icon />
			</div>
		) : null;
	};

	const {
		control,
		handleSubmit,
		reset,
		watch,
		formState: { errors, isDirty },
		register,
	} = useForm({
		mode: "onChange",
		defaultValues: {
			bio: profileData?.bio ?? "",
			dob: formatDateForInput(profileData?.dob),
			height: profileData?.height ?? "",
			weight: profileData?.weight ?? "",
			gender: profileData?.gender ?? "",
			reachOneHand: profileData?.reachOneHand ?? "",
			reachOneHandJump: profileData?.reachOneHandJump ?? "",
			city: profileData?.city ?? "",
			country: profileData?.country ?? "",
			sport: profileData?.sport ?? "",
			position: profileData?.position ?? "",
		},
	});

	const watchSport = watch("sport");

	const onBioSubmit = (data: any) => {
		http
			.patch(`/members/member`, { bio: data.bio })
			.then((response) => {
				dispatch(setProfile({ bio: response.bio }));
				setProfileData((prevData) => ({
					...prevData!,
					bio: response.bio,
				}));

				setEditBio(false);
			})
			.catch((error) => console.log(error));
	};

	const removeExperienceAction = (index: number, id?: any) => {
		if (id)
			http.delete(`/members/member/experiences/${id}`).then((response) => { });
		else setNewExp(false);
		const _expArray = expArray?.filter((_, i) => i !== index);
		setExpArray(_expArray);
	};

	const onStatsSubmit = (data: any) => {
		http
			.patch(`/members/member`, {
				dob: data.dob || null,
				height: data.height ? Number(data.height) : null,
				weight: data.weight ? Number(data.weight) : null,
				gender: data.gender || null,
				reachOneHand: data.reachOneHand ? Number(data.reachOneHand) : null,
				reachOneHandJump: data.reachOneHandJump
					? Number(data.reachOneHandJump)
					: null,
			})
			.then((response) => {
				dispatch(setProfile(response));
				setProfileData(response);
				setEditStats(false);
			})
			.catch((error) => console.log(error));
	};

	const onBasicInfoSubmit = (data: any) => {
		http
			.patch(`/members/member`, {
				city: data.city,
				country: data.country,
				sport: data.sport,
				position: data.position,
			})
			.then((response) => {
				dispatch(setProfile(response));
				setProfileData((prevData) => ({
					...prevData!,
					city: response.city,
					country: response.country,
					sport: response.sport,
					position: response.position,
				}));
				setBasicInfoModalOpen(false);
			})
			.catch((error) => console.log(error));
	};

	const manageBioField = () => {
		if (!profileData?.bio && !editBio) {
			if (actorId === params.userId)
				return (
					<>
						<div className="profile__bio">
							<Button
								className="btn btn-link profile__bio-add-btn"
								action={() => setEditBio(true)}
							>
								{t("profile.profilePage.addBioBtnLabel")}
								<Add
									style={{
										width: `20px`,
										height: `20px`,
										stroke: "white",
										marginRight: "8px",
									}}
								/>
							</Button>
						</div>
					</>
				);
		} else if (editBio) {
			return (
				<>
					<form
						className="profile__bio d-flex center column"
						onSubmit={handleSubmit(onBioSubmit)}
					>
						<AcedTextArea
							placeholder={t("profile.profilePage.addBioBtnLabel")}
							control={control}
							name="bio"
						/>

						<Button
							className="btn btn-primary profile__bio-submit"
							type="submit"
						>
							{t("profile.profilePage.addBioBtnLabel")}
						</Button>
					</form>
				</>
			);
		} else {
			return (
				<>
					<div className="profile__bio">
						<div className="d-flex justify-space-between">
							<p className=" profile__bio-title">About</p>

							{actorId === params.userId && (
								<ClickIcon
									icon="edit"
									onClick={() => setEditBio(true)}
									size={26}
								/>
							)}
						</div>
						<p className="profile__bio-box">{profileData?.bio}</p>
					</div>
				</>
			);
		}
	};

	const onUnfollow = () => {
		setFollowers((prevValue) => {
			return prevValue - 1;
		});
	};

	const onFollow = () => {
		setFollowers((prevValue) => {
			return prevValue + 1;
		});
	};

	const addExp = () => {
		if (expArray)
			setExpArray([
				...expArray,
				{
					position: "",
					from: "",
					to: "",
					team: "",
					league: { name: "", category: "" },
					description: "",
					isNew: true,
				},
			]);
		setNewExp(true);
	};

	const handlePictureSave = async (croppedBlob: Blob | null) => {
		let res;
		if (croppedBlob) {
			const formData = new FormData();
			formData.append("profilePicture", croppedBlob, "profile.png");

			res = await http.post(
				ProfilePictureApiRoutes.ADD_PROFILE_PIC(actorId),
				formData,
				{
					headers: { "Content-Type": "multipart/form-data" },
				}
			);
		} else {
			res = await http.delete(
				ProfilePictureApiRoutes.RESET_PROFILE_PIC(actorId)
			);
		}

		dispatch(setUser({ avatarVersion: res.avatarVersion }));
		setPictureModalOpen(false);
	};

	useEffect(() => {
		http
			.get(MembersApiRoutes.GET_USER(params.userId))
			.then((res) => {
				setProfileData(res);
				setExpArray(res.experiences); // Assuming res.data contains the actual profile data
				setIsFollowed(res.isFollowed || false);
			})
			.catch((error) => {
				console.error("Error fetching profile:", error);
			});

		http.get(FollowApiRoutes.GET_USER_FOLLOWERS(params.userId)).then((res) => {
			setFollowers(res.length);
		});
	}, [params.userId]); // dependency array to re-fetch when userId changes

	useEffect(() => {
		http.get("/utils/genders").then((response) => {
			setGenderOptions(
				response.map((value: string) => ({
					value,
					label:
						value === "other"
							? "Other"
							: value === "DNS"
								? "Prefer not to answer"
								: value,
				}))
			);
		});

		http.get("/utils/sports").then((response) => {
			setSportOptions(
				response.map((sport: { name: string; value: string }) => ({
					value: sport.value,
					label: t("sportData.sportsLabels." + sport.value, sport.name),
				}))
			);
		});
	}, [t]);

	useEffect(() => {
		if (profileData) {
			reset({
				bio: profileData.bio ?? "",
				dob: formatDateForInput(profileData.dob),
				height: profileData.height ?? "",
				weight: profileData.weight ?? "",
				gender: profileData.gender ?? "",
				reachOneHand: profileData.reachOneHand ?? "",
				reachOneHandJump: profileData.reachOneHandJump ?? "",
				city: profileData.city ?? "",
				country: profileData.country ?? "",
				sport: profileData.sport ?? "",
				position: profileData.position ?? "",
			});
		}
	}, [profileData, reset]);

	// Load positions when sport changes
	useEffect(() => {
		if (watchSport && profileData?.accountType === "athlete") {
			http
				.get(`/utils/positions?sport=${watchSport}`)
				.then((response) => {
					setPositionOptions(
						response.map((position: { name: string; value: string }) => ({
							value: position.value,
							label: t(
								`sportData.positions.${watchSport}.${position.value}`,
								position.name
							),
						}))
					);
				})
				.catch(() => {
					setPositionOptions([]);
				});
		} else {
			setPositionOptions([]);
		}
	}, [watchSport, profileData?.accountType, t]);

	return (
		<>
			<Header />
			<div className="profile container">
				<div className="profile__heading">
					<div className="profile__heading-profile-picture-container">
						<div
							className="profile__heading-profile-picture"
							{...(!isTouch &&
								actorId === params.userId && {
								onMouseEnter: () => setProfilePictureHovered(true),
								onMouseLeave: () => setProfilePictureHovered(false),
							})}
							{...(isTouch &&
								actorId === params.userId && {
								onTouchStart: () => setProfilePictureHovered(true),
							})}
						>
							<img
								className="profile__heading-img"
								src={
									getProfilePictureUrl(
										params.userId!,
										actorId === params.userId
											? avatarVersion
											: profileData?.avatarVersion,
										profileData?.profilePictureUrl
									) || userplaceholder
								}
								alt=""
								onError={(e) => (e.currentTarget.src = userplaceholder)}
							/>

							{isProfilePictureHovered && actorId === params.userId && (
								<div className="img-actions">
									<ClickIcon
										size="m"
										icon={avatarVersion ? "edit" : "camera"}
										onClick={() => {
											setPictureModalOpen(true);
											setProfilePictureHovered(false);
										}}
									/>
								</div>
							)}
							{SelectSportIcon()}
						</div>

						<AcedModal
							state={{
								isModalOpen: isPictureModalOpen,
								setModalOpen: setPictureModalOpen,
							}}
						>
							<SelectProfilePicture
								onCancel={() => {
									setPictureModalOpen(false);
								}}
								onSave={handlePictureSave}
								initialImageUrl={getProfilePictureUrl(actorId, avatarVersion)}
								isTouch={isTouch}
							/>
						</AcedModal>
					</div>

					<div className="profile__heading-edit-section">
						{actorId === params.userId && (
							<ClickIcon
								icon="edit"
								onClick={() => {
									console.log("Edit icon clicked, opening modal");
									setBasicInfoModalOpen(true);
								}}
								size={26}
							/>
						)}
					</div>

					<div className="profile__heading-name-section">
						<div className="profile__heading-name-section--left">
							<p className="profile__heading-name-section-title">
								{capitalizeName(profileData?.name)}{" "}
								{capitalizeName(profileData?.surname)}
							</p>
							<p className="profile__heading-name-section-subtitle">
								{`${t("sportData.sportsLabels." + profileData?.sport)} ${t(
									profileData?.accountType === "athlete" &&
										profileData.sport === "volleyball"
										? `sportData.positions.${profileData?.sport}.${profileData?.position}`
										: `${profileData?.position}`,
									{ defaultValue: "" }
								)}`}
							</p>
						</div>
					</div>

					<div className="follow-and-chat">
						{actorId !== params.userId && params.userId && (
							<>
								{/* <div>
                  <p>✓ Follows You</p>
                </div> */}
								<FollowButton
									follow_id={params.userId}
									followed={isFollowed}
									onFollow={onFollow}
									onUnfollow={onUnfollow}
									size="l"
								/>
								<MsgButton memberId={params.userId} />
							</>
						)}
					</div>

					<div className="profile__heading-info-section">
						<div className="profile__heading-divider"></div>
						<div className="d-flex justify-space-between mt-2">
							<p className="profile__heading-info-section-title">
								{`${t("common.words.location")}: `}
								<span className="profile__heading-info-section-title--gray">
									{profileData?.city}, {profileData?.country}
								</span>
							</p>
							<p
								className="profile__heading-info-section-title"
								onClick={() => {
									setFollowersModalOpen(true);
								}}
							>
								{t("profile.profilePage.followersLabel")}{" "}
								<span className="profile__heading-info-section-title--gray">
									{followers}
								</span>
							</p>
							<AcedModal
								state={{
									isModalOpen: isFollowersModalOpen,
									setModalOpen: setFollowersModalOpen,
								}}
							>
								{params.userId && <FollowersModal user_id={params.userId} />}
							</AcedModal>
						</div>
						{profileData &&
							profileData.team &&
							profileData.league &&
							profileData.position && (
								<p className="profile__heading-info-section-description">
									{t("profile.profilePage.description", {
										team: profileData.team,
										position: t(
											"sportData.positions.volleyball." + profileData.position
										),
										league: `${profileData.league.name} (${profileData.league.category})`,
									})}
								</p>
							)}
					</div>
				</div>

				{/* Edit Basic Info Modal */}
				<AcedModal
					state={{
						isModalOpen: isBasicInfoModalOpen,
						setModalOpen: setBasicInfoModalOpen,
					}}
					title="Edit Profile"
				>
					<div className="edit-basic-info-modal">
						<form onSubmit={handleSubmit(onBasicInfoSubmit)}>
							<div className="edit-basic-info-modal__fields">
								<AcedInput
									label="City"
									placeholder="City"
									control={control}
									name="city"
								/>
								<AcedInput
									label="Country"
									placeholder="Country"
									control={control}
									name="country"
								/>
								<AcedSelect
									label="Sport"
									placeholder="Select Sport"
									control={control}
									name="sport"
									options={sportOptions}
								/>
								{profileData?.accountType === "athlete" &&
									positionOptions.length > 0 && (
										<AcedSelect
											label="Position"
											placeholder="Select Position"
											control={control}
											name="position"
											options={positionOptions}
										/>
									)}
							</div>
							<div className="edit-basic-info-modal__actions">
								<Button
									className="btn btn-primary"
									action={() => setBasicInfoModalOpen(false)}
								>
									{t("profile.profilePage.cancelBtnLabel", "Cancel")}
								</Button>
								<Button
									className="btn btn-primary"
									type="submit"
								>
									{t("common.buttons.edit", "Save")}
								</Button>
							</div>
						</form>
					</div>
				</AcedModal>

				{/* {actorId === params.userId && (
					<div className="profile__availability-section ">
						<Switch
							colorOne={"#f5dd4b"}
							colorTwo={"#bbbbbb"}
							// handleToggle={toggleSwitch}
							// isOn={isToggleEnabled}
							// disabled
						></Switch>

						<div className="center">
							<p className="profile__availability-section-label">
								looking for collaboration
							</p>
						</div>
					</div>
				)} */}

				{manageBioField()}

				<div className="profile__experience-section">
					<div className="profile__experience-section-title d-flex justify-space-between">
						<p>Experience</p>
						<div className="profile__stats-section-edit">
							{actorId === params.userId && !newExp && (
								<ClickIcon
									icon="add"
									onClick={addExp}
									tooltip="Add new experience"
									size={26}
								/>
							)}
						</div>
					</div>
					<div className="experiences">
						{expArray &&
							expArray.map((exp, index) => (
								<ExperienceCard
									isDirty={isDirty}
									info={exp}
									key={index}
									register={register}
									removeExperienceAction={(index: number, id: any) =>
										removeExperienceAction(index, id)
									}
									setNewExp={(value: boolean) => setNewExp(value)}
									index={index}
									errors={errors}
									myExp={actorId === params.userId}
									sport={profileData?.sport || ""}
								/>
							))}
					</div>
				</div>

				<div className="profile__stats-section">
					<div className="d-flex justify-space-between">
						<p className="profile__stats-section-title">Data</p>
						<div className="profile__stats-section-edit">
							{actorId === params.userId && (
								<ClickIcon
									icon="edit"
									onClick={() => setEditStats(true)}
									size={26}
								/>
							)}
						</div>
					</div>
					<div className="profile__stats-grid">
						{/* Personal Info Section */}
						<div className="profile__stats-category">
							<h4 className="profile__stats-category-title">
								Personal Information
							</h4>

							<div className="profile__stats-field">
								{editStats ? (
									<AcedInput
										placeholder="Date of birth"
										name="dob"
										control={control}
										className="profile__stats-input"
										type="date"
									/>
								) : (
									<div className="profile__stats-field-content">
										<span className="profile__stats-label">Date of birth</span>
										<span className="profile__stats-value">
											{profileData?.dob || "Not specified"}
										</span>
									</div>
								)}
							</div>

							<div className="profile__stats-field">
								{editStats ? (
									<AcedSelect
										placeholder="Gender"
										control={control}
										name="gender"
										options={genderOptions}
										className="profile__stats-input"
									/>
								) : (
									<div className="profile__stats-field-content">
										<span className="profile__stats-label">Gender</span>
										<span className="profile__stats-value">
											{profileData?.gender === "other"
												? "Other"
												: profileData?.gender === "DNS"
													? "Prefer not to answer"
													: profileData?.gender || "Not specified"}
										</span>
									</div>
								)}
							</div>
						</div>

						{/* Physical Stats Section */}
						<div className="profile__stats-category">
							<h4 className="profile__stats-category-title">Physical Stats</h4>

							<div className="profile__stats-field">
								{editStats ? (
									<AcedInput
										placeholder="Height (cm)"
										control={control}
										name="height"
										className="profile__stats-input"
									/>
								) : (
									<div className="profile__stats-field-content">
										<span className="profile__stats-label">Height</span>
										<span className="profile__stats-value">
											{profileData?.height
												? `${profileData.height}cm`
												: "Not specified"}
										</span>
									</div>
								)}
							</div>

							<div className="profile__stats-field">
								{editStats ? (
									<AcedInput
										placeholder="Weight (kg)"
										control={control}
										name="weight"
										className="profile__stats-input"
									/>
								) : (
									<div className="profile__stats-field-content">
										<span className="profile__stats-label">Weight</span>
										<span className="profile__stats-value">
											{profileData?.weight
												? `${profileData.weight}kg`
												: "Not specified"}
										</span>
									</div>
								)}
							</div>
						</div>

						{/* Athletic Performance Section */}
						<div className="profile__stats-category">
							<h4 className="profile__stats-category-title">
								Athletic Performance
							</h4>

							<div className="profile__stats-field">
								{editStats ? (
									<AcedInput
										placeholder="Reach one hand (cm)"
										control={control}
										name="reachOneHand"
										className="profile__stats-input"
									/>
								) : (
									<div className="profile__stats-field-content">
										<span className="profile__stats-label">Reach one hand</span>
										<span className="profile__stats-value">
											{profileData?.reachOneHand
												? `${profileData.reachOneHand}cm`
												: "Not specified"}
										</span>
									</div>
								)}
							</div>

							<div className="profile__stats-field">
								{editStats ? (
									<AcedInput
										placeholder="Reach one hand with jump (cm)"
										control={control}
										name="reachOneHandJump"
										className="profile__stats-input"
									/>
								) : (
									<div className="profile__stats-field-content">
										<span className="profile__stats-label">
											Reach one hand with jump
										</span>
										<span className="profile__stats-value">
											{profileData?.reachOneHandJump
												? `${profileData.reachOneHandJump}cm`
												: "Not specified"}
										</span>
									</div>
								)}
							</div>
						</div>
					</div>

					<div className="d-flex center profile__experience-section-edit-btn">
						{editStats && (
							<>
								<Button
									className="btn btn-primary"
									type="submit"
									action={() => setEditStats(false)}
								>
									{t("profile.profilePage.cancelBtnLabel")}
								</Button>

								<Button
									className="btn btn-primary"
									type="submit"
									action={handleSubmit(onStatsSubmit)}
								>
									{t("common.buttons.edit")}
								</Button>
							</>
						)}
					</div>
				</div>
			</div>
			<Footer />
		</>

		// ---------------------------------------------------------

		//   <Modal
		//     isVisible={isPremiumClubVisible}
		//     animationIn="slideInDown"
		//     animationInTiming={600}
		//     animationOut="slideOutDown"
		//     animationOutTiming={600}
		//     coverScreen={true}
		//     backdropTransitionOutTiming={0}
		//     onBackdropPress={() => dispatch(setPremiumClubVisible(false))}
		//     backdropOpacity={0.9}
		//     children={<PremiumClub />}
		//   />
	);
};

export default Profile;
